import { HouseholdItem, Project } from './types';

interface ProjectsPanelProps {
  projects: Project[];
  items: HouseholdItem[];
  onAdd: () => void;
  // eslint-disable-next-line no-unused-vars
  onEdit: (project: Project) => void;
  // eslint-disable-next-line no-unused-vars
  onDelete: (project: Project) => void;
}

function ProjectsPanel({
  projects, items, onAdd, onEdit, onDelete,
}: ProjectsPanelProps) {
  return (
    <div className="hh-projects">
      <div className="hh-projects-header">
        <h2>Projects</h2>
        <button type="button" className="hh-btn hh-btn-primary" onClick={onAdd}>+ New Project</button>
      </div>

      {projects.length === 0 && (
        <p className="hh-empty">
          No projects yet. Projects are just a way to group related tasks together
          (e.g. &quot;Dog&quot;, &quot;Kitchen reno&quot;) —
          add one to start grouping tasks under it.
        </p>
      )}

      <div className="hh-project-list">
        {projects.map((project) => {
          const children = items.filter((i) => i.projectId === project.id);
          const done = children.filter((i) => i.status === 'done').length;
          return (
            <div key={project.id} className="hh-project-row" style={{ borderLeftColor: project.color }}>
              <div className="hh-project-info">
                <span className="hh-project-title">{project.title}</span>
                {project.description && (
                  <span className="hh-project-desc">{project.description}</span>
                )}
                <span className="hh-project-count">
                  {done}
                  {' '}
                  /
                  {' '}
                  {children.length}
                  {' '}
                  tasks done
                </span>
              </div>
              <div className="hh-project-actions">
                <button type="button" className="hh-btn hh-btn-small hh-btn-secondary" onClick={() => onEdit(project)}>Edit</button>
                <button type="button" className="hh-btn hh-btn-small hh-btn-danger" onClick={() => onDelete(project)}>Delete</button>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default ProjectsPanel;
